import styled from 'styled-components';

import { FilledPositionConfig } from './index';
import { NewStyleColor } from '../../../../utils/styles-constants';
import { PAGE_PADDING, getEditorScrollStyles } from '../../styles';

interface WrapperProps {
	isHidden: boolean;
	colors: (string | undefined)[] | undefined;
}

interface ImageWrapperProps {
	isActive: boolean;
}

interface ImageProps {
	url: string;
	position: FilledPositionConfig;
	thumbnailsWidth: number;
}

const DESKTOP_WIDTH = 992;

const Wrapper = styled('div')`
	flex: 1 1 auto;
	display: ${({ isHidden }: WrapperProps) => isHidden ? 'none' : 'flex'};
	padding: ${PAGE_PADDING}px;
	overflow: auto;

	${({ colors }: WrapperProps) => {
		if (!colors) {
			return '';
		}

		return `
			${colors.length === 1
				? `background-color: ${colors[0] || 'transparent'};`
				: `background: linear-gradient(90deg, ${colors[0] || 'transparent'} 50%, ${colors[1] || 'transparent'} 50%);`
			}
			background-clip: content-box;
		`;
	}}

	${getEditorScrollStyles()}
`;

const ImageWrapper = styled('div')`
	position: absolute;
	top: ${PAGE_PADDING}px;
	bottom: ${PAGE_PADDING}px;
	left: ${PAGE_PADDING}px;
	right: ${PAGE_PADDING}px;
	overflow: hidden;

	${({ isActive }: ImageWrapperProps) => isActive && `outline: 2px solid ${NewStyleColor.Blue100};`}
`;

const Image = styled('div')`
	position: absolute;
	top: 0;
	bottom: 0;
	left: 0;
	right: 0;
	background: ${({ url }: ImageProps) => `url(${url}) no-repeat`};
	background-size: cover;
	background-position: ${({ position: { phone: { left, top } } }: ImageProps) => `${left}% ${top}%`};

	${({ position: { phone: { scale } } }: ImageProps) => `transform: scale(${scale});`}

	@media screen and (min-width: ${({ thumbnailsWidth }: ImageProps) => thumbnailsWidth + PAGE_PADDING * 2 + DESKTOP_WIDTH}px) {
		background-position: ${({ position: { desktop: { left, top } } }: ImageProps) => `${left}% ${top}%`};

		${({ position: { desktop: { scale } } }: ImageProps) => `transform: scale(${scale});`}
	}
`;

export {
	Wrapper,
	ImageWrapper,
	Image,
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Editor/Spread/Background/styles.ts